import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Badge } from "@ui/badge/Badge";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import Input from "@ui/input/Input";
import Panel from "@ui/panel/Panel";
import { ITheme } from "@ui/theme/GlobalTheme";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { useTheme } from "styled-components";
import { IconArrowRight } from "../conponents/icons/IconArrowRight";
import Spacer from "@ui/spacer/Spacer";

export const S_CLIENT_STATUS_CHANGE_POPUP = new Signal<{
	cientId: number;
	statusId: number;
	newStatusId: number;
	onSuccess: () => void;
	onReject?: () => void;
} | null>("S_CLIENT_STATUS_CHANGE_POPUP");

export const ClientStatusChangePopup = () => {
	useLocale();
	const requestData = S_CLIENT_STATUS_CHANGE_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const theme = useTheme() as ITheme;

	const [statuses] = GD.B_CLIENT_STATUSES.use({});
	const [selected, setSelected] = useState<IClientStatus | undefined>();

	const [reason, setReason] = useState<{ value: string }>({
		value: "",
	});

	useEffect(() => {
		if (requestData && statuses?.data && requestData.statusId !== undefined) {
			const selectedGroup = statuses.data.find(g => g.id === requestData.statusId);
			if (selectedGroup) {
				setSelected(selectedGroup);
			}
		}
	}, [statuses, requestData]);

	if (!requestData) return <></>;

	const handleSubmit = async () => {
		setError(undefined);
		if (!reason.value) {
			setError({
				message: msg("pleaseSpecifyReason"),
				code: -1,
			});
		}
		if (reason.value && requestData && selected) {
			setBusy(true);

			const res = await GD.REQ_CLIENT_STATUS_CHANGE.request({
				client_id: requestData.cientId,
				status_id: requestData.newStatusId,
				reason: reason.value,
			});

			if (res?.error) {
				setError(res?.error);
			} else if (res?.data) {
				requestData.onSuccess();
				closePopup();
			}

			setBusy(false);
		}
	};

	// const onChange = async (m: IClientStatus) => {

	// 	setError(undefined);
	// 	setSelected(m);
	// };

	const closePopup = () => {
		S_CLIENT_STATUS_CHANGE_POPUP.invoke(null);
		setError(undefined);
		setReason({ value: "" });
	};

	const current = statuses?.data?.find(s => s.id === requestData.statusId);
	const newStatus = statuses?.data?.find(s => s.id === requestData.newStatusId);

	//!TODO: move status render to component;
	return (
		<Panel
			sx={{
				//width: "90vw",
				maxWidth: "1200px",
				padding: "0",
				minWidth: "500px",
				//width:'40vw'
			}}
			decorator="absolute"
			busy={busy}
			growContent
			label={msg("setClientStatus")}
			onClose={() => {
				if (requestData.onReject) requestData.onReject();
				closePopup();
			}}>
			<Spacer size="20px" />
			<HBox gap="5px" sx={{ alignSelf: "center" }}>
				{current && <Badge key={current.id} color="#999999" label={current.name} />} 

				<Box>
					<IconArrowRight color={theme.colors.textPrimary} />
				</Box>

				{newStatus && <Badge key={newStatus.id} color="#b3cf98" label={newStatus.name} />}
			</HBox>

			<Spacer size="20px" />

			<VBox gap="12px">
				<Input label={msg("reason_f81ab834")} data={reason} name="value" />
			</VBox>

			<Spacer size="40px" />

			<VBox sx={{ gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("submit")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
